import { getSchemeImage } from "../../../../shared/utils/schemeImages";

const PolicyCard = ({
  Logo,
  FileIcon,
  navigate,
  policyStatus,
  carName,
  carReg,
  policyNumber,
  expiryDate,
  isFirst,
  onClick,
}) => {
  return (
    <div className="policy-details-container">
      {getSchemeImage(Logo)}
      <div className="car-details">
        <h3 className="car-name">{carName}</h3>
        <div className="car-reg">{carReg}</div>
      </div>
      <div className="policy-info">
        <div className="policy-info-item">
          <div>Policy Status</div>
          <div>{policyStatus}</div>
        </div>
        <div className="policy-info-item">
          <div>Policy Number</div>
          <div>{policyNumber}</div>
        </div>
        <div className="policy-info-item">
          <div>Expiry date</div>
          <div>{expiryDate}</div>
        </div>
      </div>
      <div className="action-buttons">
        <button
          className="policy-details-btn"
          onClick={() => {
            navigate("/support?supportType=changePolicy");
          }}
        >
          Make a Change
        </button>
        <button
          className="policy-details-btn"
          onClick={() => {
            navigate("/support?supportType=cancelPolicy");
          }}
        >
          Cancel Policy
        </button>
        <button
          className="policy-details-btn-black"
          onClick={() => {
            navigate("/claim");
          }}
        >
          Report a Claim
        </button>
      </div>
      <div>
        <button type="button" className="AddButton bg-E8E8E8" onClick={onClick}>
          Policy Documents
        </button>
      </div>
    </div>
  );
};

export default PolicyCard;
